<template>
  <div class="app-container">
    <div class="div-align-lr page-top-but">
        <el-button type="primary" icon="el-icon-plus" @click.native="handleForm(null,null)">新增客户</el-button>

        <div style="width=250px"><el-input placeholder="请输入内容" v-model="searchPatrolVal" class="input-with-select">
            <el-select v-model="searchPatrolSelectVal" slot="prepend" placeholder="请选择">
                <el-option label="姓名" value="realname"></el-option>
                <el-option label="联系方式" value="tel"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click="onSearchPatrolBut"></el-button>
        </el-input></div>
    </div>

    <!-- 表格 -->
    <el-table :data="tableData" row-key="id" stripe style="width: 100%">
      <el-table-column align="center" type="index" label="序号" width="100"> </el-table-column>
      <el-table-column align="center" prop="realname" label="姓名" sortable> </el-table-column>
      <el-table-column align="center" prop="company_name" label="公司名称" sortable> </el-table-column>
      <el-table-column align="center" prop="tel" label="手机号"> </el-table-column>

      <el-table-column align="center" prop="roject[0].item_number" label="项目编号 "> </el-table-column>
      <el-table-column align="center" prop="roject[0].item_name" label="项目名称 "> </el-table-column>      

      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row),drawer = true" slot="reference" type="text" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
        
    <div class="pageWrap">
        <el-pagination background layout="prev, pager, next" :hide-on-single-page="true" :current-page.sync="pageData.current_page" :page-size="pageData.per_page" :total="pageData.total" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <!--表单-->
    <el-dialog :title="formItemTitle" :visible.sync="formVisible" :before-close="hideForm" :close-on-click-modal="false" width="1000px" top="5vh">
        <el-form :model="formData" :rules="formRules" ref="dataForm" label-width="150px">
          <!-- 客户信息 -->
          <div v-if="formItem === 0" class="form-item">
            <el-form-item label="客户ID：">
                <div>{{formData.user.username}}</div>
            </el-form-item>
            <el-form-item label="姓名：">
                <el-input v-model="formData.user.realname" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="user.tel">
                <el-input v-model="formData.user.tel" auto-complete="off" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="身份证号：">
                <el-input v-model="formData.user.idcard" auto-complete="off" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="公司名称：">
                <el-input v-model="formData.user.company_name" auto-complete="off" maxlength="18"></el-input>
            </el-form-item>
          </div>
          <!-- 完善项目信息 -->
          <div v-show="formItem === 1" class="form-item">
            <el-form-item label="项目ID：">
                <div>{{formData.p_arr.item_number}}</div>
            </el-form-item>
            <div v-if="formItem === 1">
              <el-form-item label="项目名称：" prop="p_arr.item_name">
                  <el-input v-model="formData.p_arr.item_name" auto-complete="off" placeholder="请输入项目名称"></el-input>
              </el-form-item>
              <el-form-item label="项目地址：" prop="p_arr.proCityArea">
                  <el-cascader placeholder="请点击选择地址" :options="options" v-model="formData.p_arr.proCityArea" @change="handleChange" clearable style="width:400px"></el-cascader>
              </el-form-item>
              <el-form-item label="." prop="p_arr.address">
                  <el-input v-model="formData.p_arr.address" type="textarea" :rows="3" maxlength="30" show-word-limit placeholder="请输入详细地址"> </el-input>
              </el-form-item>
              <!-- <el-form-item label="项目地址定位：" prop="p_arr.coordinate"> -->
                <!-- <el-input v-model="formData.p_arr.coordinate" type="textarea" :rows="3" placeholder="地图"> </el-input> -->
                <!-- <div class="allmap" :id="mapId"></div>
              </el-form-item> -->
            </div>
            <el-form-item label="备注说明：">
                <el-input v-model="formData.p_arr.remarks" type="textarea" :rows="6" maxlength="300" show-word-limit placeholder="请输入备注说明"> </el-input>
            </el-form-item>
            <el-form-item label="安装图纸：">
                <el-upload ref="upload" :action="uploadAPI" :data="uploadData" :headers="uploadHeaders" list-type="picture-card" :multiple="false" :limit="uplimit" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload" accept=".pdf, .jpg, .jpeg, .gif, .png, .bmp">
                        <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
          </div>
          <!-- 完善项目设备信息 -->
          <div v-show="formItem === 2" class="form-item">
            <el-form-item class="itme-text" label="项目编号">
                <div>{{formData.p_arr.item_number}}</div>
            </el-form-item>
            <el-form-item class="itme-text" label="项目名称">
                <div>{{formData.p_arr.item_name}}</div>
            </el-form-item>
            <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
            <h2 style="font-size:18px;color:#303133;font-weight:normal;margin-bottom:30px;">添加设备</h2>
            <div class="e-arr-itme" v-for="(item, index) in formData.e_arr" :key="index">
                <el-form-item label="设备ID：" style="width:100%">
                    <div>{{item.device_id}}</div>
                </el-form-item>
                <div v-if="formItem === 2">
                    <el-form-item label="设备别称：" :prop="'e_arr.' + index + '.eq_name'" :rules="{required: true, message: '请输入设备别称', trigger: 'blur'}" style="width:100%">
                        <el-input v-model="item.eq_name" auto-complete="off" placeholder="请输入设备别称,用于区分每台设备的位置" style="width:400px"></el-input>
                    </el-form-item>
                    <el-form-item label="设备序号：" :prop="'e_arr.' + index + '.grm'" :rules="{required: true, message: '请输入设备序号', trigger: 'blur'}" style="width:100%">
                        <el-input v-model="item.grm" auto-complete="off" placeholder="请输入设备序号" style="width:400px"></el-input>
                    </el-form-item>
                    <el-form-item label="设备密码：" :prop="'e_arr.' + index + '.pass'" :rules="{required: true, message: '请输入设备密码', trigger: 'blur'}" style="width:100%">
                        <el-input v-model="item.pass" auto-complete="off" placeholder="请输入设备密码" style="width:400px"></el-input>
                    </el-form-item>
                    <el-form-item label="设备监控图片地址：" :prop="'e_arr.' + index + '.img'" :rules="{required: true, message: '请输入设备监控图片地址', trigger: 'blur'}" style="width:100%">
                        <el-input v-model="item.img" auto-complete="off" placeholder="请输入设备监控图片地址" style="width:400px"></el-input>
                    </el-form-item>
                </div>
                <el-form-item label="设备说明书：" style="width:100%">
                    <el-upload ref="upload" :action="uploadAPI" :data="uploadData" :headers="uploadHeaders" list-type="picture-card" :multiple="false" :limit="uplimit" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload" :objectBind="index" accept=".pdf, .jpg, .jpeg, .gif, .png, .bmp">
                            <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible" append-to-body>
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <button v-if="index > 0" type="button" class="el-dialog__headerbtn" @click="deleteItem(item, index)"><i class="el-dialog__close el-icon el-icon-close"></i></button>
            </div>
            <el-button @click.native="addItem" type="primary" plain icon="el-icon-plus">添加更多设备</el-button>
          </div>
          <!-- 完善项目维保/巡查信息 -->
          <div v-if="formItem === 3" class="form-item">
            <el-form-item class="itme-text" label="项目编号">
                <div>{{formData.p_arr.item_number}}</div>
            </el-form-item>
            <el-form-item class="itme-text" label="项目名称">
                <div>{{formData.e_arr.item_name}}</div>
            </el-form-item>
            
            <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px;" /> 
            
            <el-form-item label="维保团队" prop="team.wb_team_id">
              <el-select v-model="formData.team.wb_team_id" placeholder="请选择">
                <el-option v-for="item in wb_team_options" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="巡查团队" prop="team.xc_team_id">
              <el-select v-model="formData.team.xc_team_id" placeholder="请选择">
                <el-option v-for="item in xc_team_options" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button v-if="formItem > 0" type="info" plain @click.native="backBut(formItem-1)">
              <span v-if="formItem === 1 ">上一步 编辑客户信息</span>
              <span v-if="formItem === 2 ">上一步 编辑项目信息</span>
              <span v-if="formItem === 3 ">上一步 编辑项目设备信息</span>
            </el-button>
            <el-button v-if="formItem <= 2" type="primary" @click.native="nextBut(formItem+1)">
              <span v-if="formItem === 0">下一步 完善项目信息</span>
              <span v-if="formItem === 1 ">下一步 完善项目设备信息</span>
              <span v-if="formItem === 2  ">下一步 完善维保/巡查信息</span>
            </el-button>
            <el-button v-if="formItem > 2" type="primary" @click.native="formSubmit()" :loading="formLoading" style="width:200px">提 交</el-button>
        </div>
    </el-dialog>
  </div>

</template>

<script>
import {customerList,isVerificationID,apiUseradd,apiGetTeam} from "../../api/views/customer";
import {loadBMap} from '../../api/map';
import {isvalidPhone,checkIdNum,getCookie} from "../../utils/rules";

const formJson = {
  "user":{//客户信息
      "username": "",//客户id
      "realname": "",//姓名
      "tel": "",//手机
      "idcard": "", //身份证
      "company_name": ""//公司名称
    },
    "p_arr":{//项目信息
      "item_number": "",//项目id
      "item_name": "",//项目名称
      "proid": "",//
      "cityid": "" ,
      "areaid": "" ,
      "address": "" ,//项目地址
      "remarks": "" ,//备注说明
      "thumb": [] ,//安装图纸
      "coordinate":"",//坐标
      proCityArea: [],
    },
    "e_arr":[],
    "team":{
        "wb_team_id":"",//维保团队数据表id
        "xc_team_id":""//巡查团队数据表id
    },
}
const formDataJson = [{
    "device_id":"",//设备id
    "eq_name":"",//设备别称
    "grm":"",//设备序号
    "pass":"",//设备密码  
    "img":"",//图片地址          
    "thumb":[]//设备说明书,上传返回的数据表id
}]
const validPhone=(rule, value,callback)=>{
  if (!value){
      callback(new Error('请输入手机号码'))
  }else  if (!isvalidPhone(value)){
    callback(new Error('请输入正确的11位手机号码'))
  }else {
      callback()
  }
}
const valcheckIdNum=(rule, value,callback)=>{
  if (!value) {
    return callback(new Error('证件号码不能为空'))
  } else if (!checkIdNumt(value)) {
    return callback(new Error('证件号码不正确'))
  } else {
    callback()
  }
}
export default {
  data() {
    return {
      query:{
          id: "",
      },
      pageData: {
          current_page: 1,
          last_page: 1,
          per_page: 1,
          total: 1
      },
      drawer: false,
      tableData: [],

      options: [],
      selectedOptions: [],
      cityArr: [], //城市列表
      areaArr: [], //区县列表
      province: "", //省
      city: "", //市
      area: "", // 区县,
      provinceCityArea: ['450000', '450100', '450102'], //选择器选择的省市区
      
      formItem: 0,
      formItemTitle: '',
      formLoading: false,
      formVisible: false,
      formData: formJson,
      formRules: {},
      userRules: {
        user: {
          realname: [
            { required: true, message: "请输入姓名", trigger: "blur" },
            // { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
          ],
          tel: [
            { required: true, message: '手机号不能为空', trigger: "blur" }
          ],
          idcard: [
            { required: true, message: "请输入身份证号", trigger: "blur" }
          ],

        }
      },
      projectRules:{
        p_arr:{
          item_name: [
            { required: true, message: "请输入姓名", trigger: "blur" }
          ],
          proCityArea: [
            { required: true, message: "请选择项目所在城市区域及详细地址", trigger: "blur" }
          ],
          address: [
            { required: true, message: "请输入详细地址", trigger: "blur" }
          ]
        },
      },
      equipmentRules:{
        e_arr:{
            eq_name:[{ required: true, message: "设备别称", trigger: "blur" }],
            grm:[{ required: true, message: "请输入设备序号", trigger: "blur" }],
            pass:[{ required: true, message: "请输入设备密码", trigger: "blur" }],
            img:[{ required: true, message: "请输入图片地址", trigger: "blur" }]
        },
      },
      maintenanceRules:{
        team:{
          wb_team_id: [{ required: true, message: "请选择维保团队", trigger: "blur" }],
          xc_team_id: [{ required: true, message: "请选择巡查团队", trigger: "blur" }],
        },
      },
      customerID: '',

      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      
      mapId: 'allmap',
      myMap: null,
      "e_arr":[],
      "wb_team_options": [],
      "xc_team_options": [],

      uploadAPIMap:{
        0: '',
        1: process.env.VUE_APP_API_BASE + '/admin/index/padd_upload',
        2: process.env.VUE_APP_API_BASE + '/admin/index/eadd_upload',
        3: ''
      },
      
      uploadAPI: '',  // 上传的Url地址 upload
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      uploadData:{},
      uplimit: 9,
      fileSuffix:'',
      uploadSwitch: false,
      uploadReply: [],
      searchPatrolSelectVal: '',
      searchPatrolVal: '',
      uploadHeaders: {}
    };
  },
  created:function() {
    this.getList({page: 1})
    this.getSite()
  },
  mounted:function(){
    this.getSite()
    // this.initMap()
  },
  methods: {
    // 刷新
    refresh() {
      this.getList({page: 1});
    },
    // 获取文件列表
    getList(page) {
      this.uploadHeaders = {
          "X-Adminid": getCookie('ADMIN-ID'),
          "X-Token": getCookie('ADMIN-TOKEN')
      }
      customerList(page).then(response => {
          this.tableData = response.user_list.data || [];
          this.pageData = response.user_list
        })
        .catch(() => {});
    },
    // 点击查看
    handleClick(row) {
      console.log(row);
      console.log(row.id);
      this.query.id = row.id
      console.log(this.query);
      this.$router.push({path:'/customer/details',query:{id:row.id}});
    },
    // 上传前钩子
    beforeUpload(file, fileList){
        const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
        const whiteList = ['pdf', 'jpg', 'jpeg', 'gif', 'png', 'bmp'];
        if (whiteList.indexOf(fileSuffix) === -1) {
            this.$message({
                message: "上传文件格式错误！",
                type: "error"
            })
            return false;
        }
        // const isLt2M = file.size / 1024 / 1024 < 4;
        // if (!isLt2M) {
        //     this.$message({
        //         message: "上传文件大小不能超过 4MB！",
        //         type: "error"
        //     })
        //     return false;
        // }
        this.uploadData.upload = file
        this.fileSuffix = file.name.substring(file.name.lastIndexOf('.')+1)
        this.fileFormat = file.type.toString().split('/')
        console.log('filedfgsf',fileList)
    },
    // 上传成功的回调钩子
    handleSuccess(response, file, fileList , index){
        console.log(this.βimgBaseUrl + response.path)
        response.name = file.name
        this.uploadReply.push(response)
        if(this.fileFormat[0] == 'image') {
            // file.url = file.url
            file.url = this.βimgBaseUrl + response.path
        }else if(this.fileFormat[0] == 'video'){
            file.url = 'http://app.shengren.work/wanshuiqing/video.png'
        }else if(this.fileSuffix == 'pdf'){
            file.url = 'http://app.shengren.work/wanshuiqing/pdf.png'
        }else{
            file.url = 'http://app.shengren.work/wanshuiqing/file.png'
        }
        console.log(index)
        console.log(this.formData.e_arr)
        if(this.formItem === 1) this.formData.p_arr.thumb.push(response.id)
        if(this.formItem === 2) this.formData.e_arr[index].thumb.push(response.id)
    },
    // 上传失败的回调钩子
    handleError(response, file, fileList) {
        console.log('error-----------')
        // console.log(response)
        console.log(file)
        console.log('response',this.$refs.upload)
        // this.isImporting = false
        // this.$refs.upload.clearFiles()
    },
    // 移除文件钩子
    handleRemove(file, fileList) {
        const newArr = this.uploadReply.filter((item) => {
            return !file.name.includes(item.name)
        })
        this.uploadReply = newArr
        console.log(newArr)
        console.log(this.uploadReply)
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
        console.log(this.fileFormat[0])
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
        console.log(file.url)
        console.log(this.uploadReply)
        console.log(this.uploadFiles)
        console.log(this.clearFiles)
        console.log(this.fileList)
    },
    // 隐藏表单
    hideForm() {
        // 更改值
        this.formVisible = !this.formVisible;
        // 清空表单
        this.formItem = 0;
        // this.$nextTick(()=>{this.$refs["dataForm"].resetFields()})
        this.$refs["dataForm"].resetFields()
        return true;
    },
    // 显示表单
    handleForm(index, row) {
        apiGetTeam().then(res => {
          console.log(res)
          this.wb_team_options = res.wb_team_list
          this.xc_team_options = res.xc_team_list
        })
        this.formData.e_arr = Array.from(formDataJson)
        this.formData.user.username = this.random('KH',1,1000000)
        this.formData.p_arr.item_number = this.random('XM',1,1000000)
        this.formData.e_arr[0].device_id = this.random('SB',1,1000000)
        this.uploadAPI = this.uploadAPIMap[0]
        this.formVisible = true
        this.formData = Object.assign({}, formJson);
        // if (row !== null) {
        //     this.formData = Object.assign({}, row);
        // }
        this.formItemTitle = "客户信息";
        this.formRules = this.userRules;
        // 清空验证信息表单
        if (this.$refs["dataForm"]) this.$refs["dataForm"].clearValidate();
        this.initDistPicker()
        if(!this.formData.p_arr.coordinate) this.getSite();
    },
    // 提交表单
    formSubmit() {
        this.$refs["dataForm"].validate(valid => {
            if (valid) {
                        let newEallObj = {}, data = {}, newFormData = JSON.parse(JSON.stringify(this.formData))
                        this.formLoading = true
                        delete newFormData.p_arr['proCityArea']
                        newFormData.p_arr.coordinate = '108.33882,22.819822'
                        console.log(newFormData.p_arr)
                        if(newFormData.p_arr.thumb.length > 0) {
                            newFormData.p_arr.thumb = newFormData.p_arr.thumb.toString()
                        }else{
                            delete newFormData.p_arr['thumb']
                            newFormData.p_arr.thumb = ''
                        }
                        for(let i of newFormData.e_arr) {
                            if(i.thumb.length > 0)  i.thumb = i.thumb.toString()
                        }
                        newFormData.e_arr.forEach((item,index) => {
                            newEallObj[index] = item
                        })
                        newFormData.e_arr = newEallObj
                        data = newFormData
                        console.log(data)
                apiUseradd(data).then(response => {
                  this.formLoading = false;
                  console.log(response)
                  if (response.code == 0) {
                    this.$message({
                      message: "操作成功",
                      type: "success"
                    });
                    // 清空/隐藏表单
                    this.formItem = 0;
                    // this.$nextTick(()=>{this.$refs["dataForm"].resetFields()})
                    this.$refs["dataForm"].resetFields()
                    this.hideForm()
                    // 刷新列表
                    this.refresh()
                  } else {
                    this.$message({
                      message: response.message,
                      type: "error"
                    })
                  }
                })
            }
        });
    },
    // 随机客户ID/项目ID
    random(type, min, max) {
        const that = this,
            num = type + Math.floor(Math.random() * (max - min)) + min,
            queryMap = {
                'KH':{username:num},
                'XM':{item_number:num},
                'SB':{device_id:num}
            },
            query = queryMap[type]
        ~function verusername() {
            isVerificationID(type,query).then(res => {
                if(res == 0){
                    return num
                }else{
                    return verusername()
                }
            }).catch(() => {});
        }()
        return num
    },
    //
    backBut(index){
        this.formItem--
        this.getformName(index)
        this.uploadAPI = this.uploadAPIMap[index]
    },
    //
    nextBut(index){
      const that = this
      console.log('index--',index)
      this.$refs["dataForm"].validate(valid => {
          if (valid) {
            this.formItem++
            this.getformName(index)
            this.uploadAPI = this.uploadAPIMap[index]
            if(index = 1){
              if(!this.myMap) setTimeout(() => {
                this.initMap(this.formData.p_arr.coordinate);
              }, 500) 
            }
            if(index = 2) this.random('SB',1,1000000);
            if(index = 3){
            }
          }
      })
      console.log(this.formData)

    },
    getformName (index){
      const that = this;
      switch (index) {
        case 1:
          that.formItemTitle = "完善项目信息";
          that.formRules = that.projectRules;
          break;
        case 2:
          that.formItemTitle = "完善项目设备信息";
          that.formRules = that.equipmentRules;
          break;
        case 3:
          that.formItemTitle = "完善项目维保/巡查信息";
          that.formRules = that.maintenanceRules;
          break;
        default:
          that.formItemTitle = "客户信息";
          that.formRules = that.userRules;
      }
    },
    // 地区初始化
    initDistPicker() {
      let self = this;
      this.$http.get("./china-main-city/districts.json").then(function(respones) {
        console.log("respones==>", respones);
        let distData = respones.data;
        let options = [];
        // 省
        for (var provinceKy in distData["100000"]) {
          let optProvinceItem = {
            value: provinceKy,
            label: distData["100000"][provinceKy]
          };
          if (distData[provinceKy]) {
            // 市
            for (var cityKy in distData[provinceKy]) {
              optProvinceItem.children = optProvinceItem.children
                ? optProvinceItem.children
                : [];
              let optCityItem = {
                value: cityKy,
                label: distData[provinceKy][cityKy]
              };
              if (distData[cityKy]) {
                // 区
                for (var areaKy in distData[cityKy]) {
                  optCityItem.children = optCityItem.children
                    ? optCityItem.children
                    : [];
                  let optAreaItem = {
                    value: areaKy,
                    label: distData[cityKy][areaKy]
                  };
                  optCityItem.children.push(optAreaItem);
                }
              }
              optProvinceItem.children.push(optCityItem);
            }
          }
          options.push(optProvinceItem);
        }
        self.distData = distData;
        self.options = options;
      });
    },
    //选择地区
    handleChange(value) {
      let self = this;
      console.log("value=>", value);
      //获取省名
      self.options.map((item, index) => {
        if (item.value == value[0]) {
          self.cityArr = item.children; //存储城市列表
          self.province = item.label;
        }
      });
      //获取市名
      self.cityArr.map((item, index) => {
        if (item.value == value[1]) {
          self.areaArr = item.children; //存储区县列表
          self.city = item.label;
        }
      });
      //获取区县名
      self.areaArr.map((item, index) => {
        if (item.value == value[2]) {
          self.area = item.label;
        }
      });
      self.provinceCityArea = self.province + self.city + self.area;
      console.log("self.provinceCityArea", self.provinceCityArea);
      self.formData.p_arr.proid = self.province
      self.formData.p_arr.cityid = self.city
      self.formData.p_arr.areaid = self.area
      console.log(self.formData.p_arr)
    },
    // 获取当前地理位置
    getSite(){
      loadBMap().then(() => {
        var that = this
        var geolocation = new BMap.Geolocation(); 
        var gc = new BMap.Geocoder();
        geolocation.getCurrentPosition(function(result){
            if(this.getStatus() == BMAP_STATUS_SUCCESS){
              var point = result.point;
              that.formData.p_arr.coordinate =  point.lng + "," + point.lat
              gc.getLocation(point,function(r){
                  var cityName = r.addressComponents.city;
                  console.log(cityName)
              })
            }else{
              alert('无法获取您的位置！')
            }
        },{enableHighAccuracy: true})
      }).catch(err => {
        console.log('获取当前地理位置-失败',err)
      })
    },
    // 百度地图API功能
    initMap(lnglat) {
      const that = this
      if(lnglat){
        let lng = parseFloat(lnglat.split(',')[0]),lat = parseFloat(lnglat.split(',')[1])
        loadBMap().then(() => {
          var map = new BMap.Map("allmap");
          var point = new BMap.Point(lng,lat);
          map.centerAndZoom(point,14)
          map.enableScrollWheelZoom(); //开启滚动缩放
          map.enableContinuousZoom(); //开启缩放平滑
          // var marker = new BMapGL.Marker(new BMapGL.Point(point));
          // map.addOverlay(marker);
          // map.addOverlay(new BMap.Marker(new BMap.Point(point)));
          var geoc = new BMap.Geocoder();  
          map.addEventListener("click", function(e){        
            var pt = e.point;
            geoc.getLocation(pt, function(rs){
              var addComp = rs.addressComponents;
              console.log(addComp.province + ", " + addComp.city + ", " + addComp.district + ", " + addComp.street + ", " + addComp.streetNumber + ", " + e.point.lng + "," + e.point.lat );
              that.formData.p_arr.proid = addComp.province
              that.formData.p_arr.cityid = addComp.city
              that.formData.p_arr.areaid = addComp.district
              that.formData.p_arr.address = addComp.street + addComp.streetNumber
              that.formData.p_arr.coordinate = e.point.lng + "," + e.point.lat
              console.log(that.formData.p_arr)
              
            });        
          });
          map.addControl(
            new BMap.MapTypeControl({
              mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
            })
          )
          that.myMap = map
				  return
        }).catch(err => {
          console.log('地图加载失败3',err)
          // that.asaError = setInterval(() => {
          //   // that.getSite()
          //   console.log(lnglat)
          //   // that.initMap(lnglat)
          // }, 1000)
          // setTimeout(() => {
          //   clearInterval(that.asaError)
          //   console.log(that.asaError)
          // }, 5000)
				  return
          
        
        })
      }else{
        that.getSite()
        that.initMap(lnglat)
      }
    },
    //  文件上传带缩略图
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      console.log(file)
    },
    handleDownload(file) {
      console.log(file);
    },
    addItem () {
        this.formData.e_arr.push({
            device_id: this.random('SB',1,1000000),
            "eq_name":"",
            "grm":"",
            "pass":"",
            "img":"",        
            "thumb":[]
        })
    },
    deleteItem (item, index) {
        this.formData.e_arr.splice(index, 1)
    },
    handleCurrentChange: function(currentPage){
        this.getList({page:currentPage})
    },
    onSearchPatrolBut(){
        console.log('搜索')
        this.query = {}
        this.query[this.searchPatrolSelectVal] = this.searchPatrolVal
        if(this.searchPatrolSelectVal && this.searchPatrolVal){
            this.getList(this.query)
        }else if(!this.searchPatrolSelectVal){
            this.$message({
                message: '搜索类型不能为空',
                type: "error"
            })
        }else if(!this.searchPatrolVal){
            this.$message({
                message: '搜索内容不能为空',
                type: "error"
            })
        }
    },
  }
};
</script>

<style lang="scss" scoped>
  .dialog-footer{
    width: 100%;
    text-align: center;
  }
 .el-form-item{
    width: 90%;
  }
  .itme-text{
    margin-bottom: 0;
  }
  .itme-text label.el-form-item__label{
    width: 80px !important;
  }
  .allmap {width: 90%;height: 400px;overflow: hidden;margin:0;}
  .e-arr-itme {
    position: relative;
    border: 1px dashed #d9d9d9;
    margin: 30px 0;
    padding: 30px 0;
  }
  .pageWrap{
      padding: 30px 0;
      text-align: center;
  }
  
</style>
